<template>
  <div
    class="option-card"
    :class="{
      selected,
      pulse: selected,
      disabled,
      unavailable
    }"
    @click="handleClick"
  >
    <div class="option-icon" v-if="icon" :style="{ color: color }">{{ icon }}</div>
    <div class="option-text">{{ label }}</div>
    <div class="option-description" v-if="description">{{ description }}</div>
  </div>
</template>

<script>
export default {
  name: 'OptionListItem',
  props: {
    label: String,
    value: [String, Number],
    selected: Boolean,
    description: String,
    icon: String,
    color: String,
    disabled: Boolean,
    unavailable: Boolean
  },
  methods: {
    handleClick() {
      if (!this.disabled && !this.unavailable) {
        this.$emit('select', this.value);
      }
    }
  }
};
</script>

<style scoped>
.option-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: white;
  border: 2px solid #e8f5f3;
  border-radius: 12px;
  padding: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.option-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(32, 120, 104, 0.08), transparent);
  transition: left 0.5s ease;
}
.option-card:hover {
  border-color: #207868;
  box-shadow: 0 6px 18px rgba(32, 120, 104, 0.12);
  transform: translateY(-2px);
}
.option-card:hover::before {
  /* left: 100%; */
}
.option-card:hover .option-icon {
  transform: scale(1.06);
  box-shadow: 0 5px 16px rgba(32, 120, 104, 0.18);
}
.option-card:active {
  transform: translateY(0);
}

.option-text {
  font-size: 24px;
  color: #207868;
  font-weight: bold;
}
.option-description {
  margin-top: 6px;
  font-size: 18px;
  color: #666;
  line-height: 1.4;
}
.option-icon {
  font-size: 40px;
  margin-bottom: 12px;
  color: #2a9d8f;
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #e8f5f3 0%, #f0f9f7 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px auto;
  box-shadow: 0 3px 12px rgba(32, 120, 104, 0.1);
  transition: all 0.3s ease;
}

.selected {
  border-color: #207868;
  background: linear-gradient(135deg, #e8f5f3 0%, #f0f9f7 100%);
}
.pulse {
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(32, 120, 104, 0.35); }
  70% { box-shadow: 0 0 0 10px rgba(32, 120, 104, 0); }
  100% { box-shadow: 0 0 0 0 rgba(32, 120, 104, 0); }
}

/* Disabled state - grayed out */
.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #f5f5f5;
  border-color: #ccc;
}
.disabled:hover {
  border-color: #ccc;
  box-shadow: none;
  transform: none;
}
.disabled:hover::before {
  display: none;
}
.disabled:hover .option-icon {
  transform: none;
  box-shadow: 0 3px 12px rgba(32, 120, 104, 0.1);
}
.disabled .option-text {
  color: #999;
}
.disabled .option-icon {
  color: #999;
  background: #f0f0f0;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.1);
}

/* Unavailable state - faded, softer green */
.unavailable {
  opacity: 0.7;
  cursor: not-allowed;
  border-color: #a8d5c9;
  background: linear-gradient(135deg, #f8fcfb 0%, #f5fbfa 100%);
}
.unavailable:hover {
  border-color: #a8d5c9;
  box-shadow: 0 3px 12px rgba(168, 213, 201, 0.12);
  transform: none;
}
.unavailable:hover::before {
  display: none;
}
.unavailable:hover .option-icon {
  transform: none;
  box-shadow: 0 3px 12px rgba(168, 213, 201, 0.1);
}
.unavailable .option-text {
  color: #5a9b8a;
}
.unavailable .option-icon {
  color: #5a9b8a;
  background: linear-gradient(135deg, #f8fcfb 0%, #f5fbfa 100%);
  box-shadow: 0 3px 12px rgba(168, 213, 201, 0.1);
}

@media (max-width: 768px) {
  .option-icon { display: none; }
}
</style>
